import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { motion, AnimatePresence } from "framer-motion"; // 🔥 Added Framer Motion
import { httpRequest } from "../../redux/Action";
import { API_END_POINTS } from "../../api/ApiEndPonts";



export default function PYQTest() {
  const { year } = useParams();
  const dispatch = useDispatch();

  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [showResult, setShowResult] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);


  useEffect(() => {
    dispatch(
      httpRequest({
        key: API_END_POINTS.getAllPYQ.KEY,
        onSuccess: (res) => {
          const filtered = res.data.filter((q) => q.year?.toString() === year);
          setQuestions(filtered);
        },
        onError: (err) => {
          console.log("Error fetching questions:", err);
        }
      }),
    );
  }, [year, dispatch]);

  useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
  };

  window.addEventListener("resize", handleResize);

  // cleanup (important)
  return () => window.removeEventListener("resize", handleResize);
}, []);

  const currentQuestion = questions[currentIndex];
  const userSelection = answers[currentIndex];

  const handleSelection = (selectedOpt) => {
    if (userSelection) return;
    setAnswers({ ...answers, [currentIndex]: selectedOpt });
  };


  const calculateScore = () => {
    let right = 0;
    let wrong = 0;
    questions.forEach((q, i) => {
      if (answers[i]) {
        if (answers[i] === q.correctAnswer) right++;
        else wrong++;
      }
    });
    return {
      right,
      wrong,
      total: questions.length,
      attempted: Object.keys(answers).length,
    };
  };

  const styles = {
    page: {
      backgroundColor: "#0f172a",
      minHeight: "100vh",
      color: "#f8fafc",
      fontFamily: "'Inter', sans-serif",
      paddingTop: "100px",
      paddingBottom: "100px",
    },
    navbar: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      height: "70px",
      background: "rgba(15, 23, 42, 0.9)",
      backdropFilter: "blur(10px)",
      borderBottom: "1px solid rgba(255,255,255,0.1)",
      zIndex: 100,
      display: "flex",
      justifyContent: "center",
    },
    navInner: {
      width: "90%",
      maxWidth: "1200px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    logoCircle: {
      width: "35px",
      height: "35px",
      background: "linear-gradient(135deg, #6366f1 0%, #a855f7 100%)",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "bold",
      marginRight: "10px",
    },
    brand: { display: "flex", alignItems: "center" },
    progressTrack: {
      flex: 1,
      maxWidth: "300px",
      height: "6px",
      background: "#334155",
      borderRadius: "10px",
      margin: "0 20px",
      overflow: "hidden",
    },
    progressFill: {
      height: "100%",
      background: "linear-gradient(90deg, #6366f1, #a855f7)",
    },
    mainContent: { width: "90%", maxWidth: "1200px", margin: "0 auto" },
    quizGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1.2fr 0.8fr",
      gap: isMobile ? "15px" : "30px",
    },
    questionSection: {
      order: isMobile ? 2 : 0,
      background: "rgba(30, 41, 59, 0.4)",
      padding: isMobile ? "20px" : "30px",
      borderRadius: "24px",
    },
    questionHeader: {
      marginBottom: "15px",
    },
    qNumber: {
      fontSize: "0.85rem",
      color: "#818cf8",
      fontWeight: "600",
      textTransform: "uppercase",
    },
    questionText: {
      fontSize: isMobile ? "1.1rem" : "1.4rem",
      lineHeight: "1.5",
      color: "#fff",
      marginBottom: "20px",
    },
    optionsWrapper: { display: "flex", flexDirection: "column", gap: "12px" },
    optionCard: {
      display: "flex",
      alignItems: "center",
      padding: isMobile ? "14px" : "18px",
      borderRadius: "16px",
      cursor: "pointer",
      border: "none",
      color: "#fff",
      textAlign: "left",
      fontSize: isMobile ? "14px" : "16px",
    },
    optionLetter: {
      width: "30px",
      height: "30px",
      borderRadius: "8px",
      background: "rgba(0,0,0,0.2)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: "15px",
      fontWeight: "bold",
    },
    sidebar: {
      position: "relative",
      order: isMobile ? 2 : 0,
      minHeight: "200px",
      transition: "all 5s cubic-bezier(1, 1, 1, 1)",
    },
    sidebarInner: {
      background: "rgba(30, 41, 59, 0.7)",
      padding: "24px",
      borderRadius: "24px",
      border: "1px solid rgba(168, 85, 247, 0.3)",
      boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3)",
      backdropFilter: "blur(12px)",
      position: isMobile ? "relative" : "sticky",
      top: isMobile ? "0" : "100px",
      overflow: "hidden",
    },
    explanationText: {
      fontSize: "0.95rem",
      lineHeight: "1.6",
      color: "#cbd5e1",
      animation: "fadeInText 3s ease-in",
    },
    footerNav: {
      position: "fixed",
      bottom: "30px",
      left: 0,
      right: 0,
      display: "flex",
      justifyContent: "center",
    },
    footerInner: {
      background: "rgba(30, 41, 59, 0.9)",
      padding: "10px 20px",
      borderRadius: "100px",
      display: "flex",
      alignItems: "center",
      gap: "20px",
      border: "1px solid rgba(255,255,255,0.1)",
      backdropFilter: "blur(10px)",
    },
    navBtn: {
      background: "transparent",
      border: "none",
      color: "#fff",
      cursor: "pointer",
      fontWeight: "600",
      padding: "10px",
    },
    submitBtn: {
      background: "#6366f1",
      color: "#fff",
      border: "none",
      padding: "10px 25px",
      borderRadius: "50px",
      fontWeight: "bold",
      cursor: "pointer",
    },
    resultContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "70vh",
    },
    resultCard: {
      background: "#1e293b",
      padding: "50px",
      borderRadius: "30px",
      textAlign: "center",
      maxWidth: "600px",
      width: "90%",
      border: "1px solid rgba(255,255,255,0.1)",
    },
    scoreGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
      gap: "15px",
      marginBottom: "30px",
    },
    scoreBox: (col) => ({
      background: "rgba(255,255,255,0.03)",
      padding: "20px",
      borderRadius: "20px",
      borderTop: `4px solid ${col}`,
    }),
    scoreLabel: {
      display: "block",
      fontSize: "0.75rem",
      color: "#94a3b8",
      textTransform: "uppercase",
      marginBottom: "5px",
    },
    scoreValue: { fontSize: "1.2rem", fontWeight: "bold" },
    restartBtn: {
      background: "linear-gradient(135deg, #6366f1, #a855f7)",
      color: "#fff",
      border: "none",
      padding: "15px 30px",
      borderRadius: "12px",
      fontWeight: "bold",
      cursor: "pointer",
    },
    btpyq: {
      background: "rgba(255,255,255,0.05)",
      color: "#fff",
      border: "1px solid rgba(255,255,255,0.1)",
      padding: "15px 30px",
      borderRadius: "12px",
      fontWeight: "bold",
      cursor: "pointer",
      textDecoration: "none",
    },
    loader: {
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#fff",
    },
  };

  if (!currentQuestion && !showResult)
    return <div style={styles.loader}>Fetching Questions...</div>;

  if (showResult) {
    const { right, wrong, total, attempted } = calculateScore();
    return (
      <div style={styles.page}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          style={styles.resultContainer}
        >
          <div style={styles.resultCard}>
            <motion.h2
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              transition={{ type: "spring" }}
            >
              Test Completed! 🏆
            </motion.h2>
            <p style={{ color: "#94a3b8", marginBottom: "30px" }}>
              NEET {year} Performance Summary
            </p>

            <div style={styles.scoreGrid}>
              {[
                { label: "Correct", val: right, col: "#10b981" },
                { label: "Wrong", val: wrong, col: "#ef4444" },
                {
                  label: "Attempted",
                  val: `${attempted}/${total}`,
                  col: "#3b82f6",
                },
              ].map((item, idx) => (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.1 }}
                  style={styles.scoreBox(item.col)}
                >
                  <span style={styles.scoreLabel}>{item.label}</span>
                  <span style={styles.scoreValue}>{item.val}</span>
                </motion.div>
              ))}
            </div>

            <div
              style={{ display: "flex", gap: "10px", justifyContent: "center" }}
            >
              <button
                style={styles.restartBtn}
                onClick={() => window.location.reload()}
              >
                Try Again
              </button>
              <NavLink to={`/user/previous-year-papers`} style={styles.btpyq}>
                Back to PYQ
              </NavLink>
            </div>
          </div>
        </motion.div>
      </div>
    );
  }

  const progress =
    questions.length > 0 ? ((currentIndex + 1) / questions.length) * 100 : 0;

  return (
    <div style={styles.page}>
      <nav style={styles.navbar}>
        <div style={styles.navInner}>
          <div style={styles.brand}>
            <div style={styles.logoCircle}>{year?.slice(-2)}</div>
            <h4 style={{ margin: 0 }}>NEET {year}</h4>
          </div>
          <div style={styles.progressTrack}>
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: `${progress}%` }}
              style={styles.progressFill}
            />
          </div>
          <div style={{ fontWeight: "bold", color: "#818cf8" }}>
            {currentIndex + 1}/{questions.length}
          </div>
        </div>
      </nav>

      <main style={styles.mainContent}>
        <div style={styles.quizGrid}>
          {/* QUESTION SECTION */}
          <motion.section
            key={currentIndex} // Resets animation on new question
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            style={styles.questionSection}
          >
            <div style={styles.questionHeader}>
              <span style={styles.qNumber}>Question {currentIndex + 1}</span>
            </div>
            <h2 style={styles.questionText}>{currentQuestion?.question}</h2>

            <div style={styles.optionsWrapper}>
              {currentQuestion?.options.map((opt, i) => {
                const isCorrect = opt === currentQuestion.correctAnswer;
                const isUserChoice = userSelection === opt;
                let bg = "#1e293b";
                let border = "1px solid rgba(255,255,255,0.1)";

                if (userSelection) {
                  if (isCorrect) {
                    bg = "#059669";
                    border = "1px solid #10b981";
                  } else if (isUserChoice) {
                    bg = "#b91c1c";
                    border = "1px solid #ef4444";
                  }
                }

                return (
                  <motion.button
                    key={i}
                    whileHover={!userSelection ? { scale: 1.02, x: 10 } : {}}
                    whileTap={!userSelection ? { scale: 0.98 } : {}}
                    initial={{ opacity: 0, x: -10 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: i * 0.05 }}
                    disabled={!!userSelection}
                    onClick={() => handleSelection(opt)}
                    style={{ ...styles.optionCard, background: bg, border }}
                  >
                    <span style={styles.optionLetter}>
                      {String.fromCharCode(65 + i)}
                    </span>
                    <span style={{ flex: 1 }}>{opt}</span>
                  </motion.button>
                );
              })}
            </div>
          </motion.section>

          {/* EXPLANATION SIDEBAR */}
          <aside style={styles.sidebar}>
            <AnimatePresence mode="wait">
              {userSelection && (
                <motion.div
                  initial={{ opacity: 0, scale: 0.5, y: 20 }}
                  animate={{ opacity: 1, scale: 1, y: 0 }}
                  transition={{
                    duration: 2,
                    type: "spring",
                    bounce: 0.3,
                    opacity: { duration: 1.5 }, // Opacity thoda jaldi start hogi
                  }}
                  style={styles.sidebarInner}
                >
                  <h4 style={{ color: "#a855f7", margin: "0 0 10px 0" }}>
                    💡 Explanation
                  </h4>
                  <p style={styles.explanationText}>
                    {currentQuestion.explanation}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </aside>
        </div>
      </main>

      <footer style={styles.footerNav}>
        <div style={styles.footerInner}>
          <button
            style={styles.navBtn}
            disabled={currentIndex === 0}
            onClick={() => setCurrentIndex(currentIndex - 1)}
          >
            ← Prev
          </button>
          {currentIndex === questions.length - 1 ? (
            <button
              style={styles.submitBtn}
              onClick={() => setShowResult(true)}
            >
              Submit Test
            </button>
          ) : (
            <button
              style={styles.navBtn}
              onClick={() => setCurrentIndex(currentIndex + 1)}
            >
              Skip →
            </button>
          )}
        </div>
      </footer>
    </div>
  );
}
